import React from 'react';
import { Zap, Keyboard, History, MonitorSmartphone, Sparkles, Monitor } from 'lucide-react';
import Card from '../../../components/Card/Card';
import SectionHeader from '../../../components/SectionHeader/SectionHeader';

function DictaphoneLiveTab() {
  return (
    <>
      {/* Section: Introduction */}
      <Card className="card-large">
        <SectionHeader icon={Zap} title="Dictée Live" variant="default" />
        <div className="guide-section-content">
          <div className="guide-info">
            <Zap className="guide-info-icon" size={20} />
            <p>
              La <strong>Dictée Live</strong> transcrit instantanément votre voix en texte.
              Idéal pour dicter rapidement dans n'importe quelle application.
            </p>
          </div>
          <span className="guide-badge-gold">Gold / Enterprise</span>
        </div>
      </Card>

      {/* Section: Comment ça marche */}
      <Card className="card-large">
        <SectionHeader icon={MonitorSmartphone} title="Comment ça marche" variant="info" />
        <div className="guide-section-content">
          <div className="guide-steps">
            <div className="guide-step">
              <span className="guide-step-number">1</span>
              <div className="guide-step-content">
                <h4>Ouvrez la Dictée Live</h4>
                <p>Depuis l'accueil ou avec le raccourci clavier configuré.</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">2</span>
              <div className="guide-step-content">
                <h4>Dictez</h4>
                <p>Parlez et voyez le texte apparaître en temps réel.</p>
              </div>
            </div>
            <div className="guide-step">
              <span className="guide-step-number">3</span>
              <div className="guide-step-content">
                <h4>Copiez ou insérez</h4>
                <p>Sur bureau, le texte peut être inséré directement dans votre application.</p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Section: Mise en forme */}
      <Card className="card-large">
        <SectionHeader icon={Sparkles} title="Option: Mise en forme" variant="success" />
        <div className="guide-section-content">
          <div className="guide-tip">
            <Sparkles className="guide-tip-icon" size={20} />
            <p>
              Activez <strong>"Mettre en forme"</strong> pour que l'IA structure
              automatiquement votre texte (ponctuation, paragraphes, mise en page).
            </p>
          </div>
        </div>
      </Card>

      {/* Section: Fonctionnalités */}
      <Card className="card-large">
        <SectionHeader icon={Zap} title="Fonctionnalités" variant="default" />
        <div className="guide-section-content">
          <div className="guide-features">
            <div className="guide-feature">
              <div className="guide-feature-icon orange">
                <Zap size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Transcription instantanée</h4>
                <p>Le texte apparaît en temps réel pendant que vous parlez</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon purple">
                <History size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Historique de session</h4>
                <p>Naviguez entre vos 15 dernières dictées</p>
              </div>
            </div>
            <div className="guide-feature">
              <div className="guide-feature-icon green">
                <Keyboard size={20} />
              </div>
              <div className="guide-feature-text">
                <h4>Raccourcis clavier</h4>
                <p>Contrôlez tout au clavier (bureau uniquement)</p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Section: Bureau */}
      <Card className="card-large">
        <SectionHeader icon={MonitorSmartphone} title="Sur l'application bureau" variant="info" />
        <div className="guide-section-content">
          <div className="guide-info">
            <Monitor className="guide-info-icon" size={20} />
            <p>
              Sur l'app bureau, la Dictée Live peut <strong>insérer le texte directement </strong>
              dans votre application active (Word, email, dossier patient...).
              Utilisez le raccourci clavier pour basculer rapidement.
            </p>
          </div>
        </div>
      </Card>
    </>
  );
}

export default DictaphoneLiveTab;
